import { useTranslations } from 'next-intl'

import { Spinner } from '@/shared/ui'

export const PassportOCRLoading = () => {
  const t = useTranslations('passport_verification')

  return (
    <div className="flex flex-col items-center gap-6 pt-[76px]">
      <Spinner size="small" className="static" />
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="typo-headline3 font-semibold">{t('scanning.title')}</p>
        <p className="typo-label1 whitespace-break-spaces text-gray-600">
          {t('scanning.description')}
        </p>
      </div>
    </div>
  )
}
